import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';
import {
  ObjectToCamel,
  objectToCamel,
  objectToSnake,
  ObjectToSnake,
} from 'ts-case-convert';
import { ClerkCreateGuardianshipResponse } from '../interfaces/clerk-create-guardianship-response.interface';
import { AdminProbate } from '@domains/admin/models/admin-probate.model';
import { CreateClerkProbateBody } from '@domains/admin/models/clerk-probate-http.models';
import { MinorApplicationClerkCreateResponse } from '../../components/clerk-create-minor-form/interfaces/clerk-create-minor-app.interface';
import {
  ClerkCreateTrustPayload,
  TrustClerkCreateApplicationResponse,
} from '../interfaces/clerk-create-trust.interface';

@Injectable({ providedIn: 'root' })
export class ClerkCreateApplicationHttpService {
  private readonly _http = inject(HttpClient);

  public createGuardianship(
    courtId: number,
    createData: FormData,
  ): Observable<ClerkCreateGuardianshipResponse> {
    return this._http
      .post<ObjectToSnake<ClerkCreateGuardianshipResponse>>(
        `${environment.api}/courts/${courtId}/guardians/`,
        createData,
      )
      .pipe(map((response) => objectToCamel(response)));
  }

  public createClerkProbate(
    courtId: number,
    body: CreateClerkProbateBody,
  ): Observable<AdminProbate> {
    return this._http.post<AdminProbate>(
      `${environment.api}/courts/${courtId}/probates/`,
      objectToSnake(body),
    );
  }

  public createClerkMinor(
    courtId: number,
    createData: FormData,
  ): Observable<ObjectToCamel<MinorApplicationClerkCreateResponse>> {
    return this._http
      .post<ObjectToSnake<MinorApplicationClerkCreateResponse>>(
        `${environment.api}/courts/${courtId}/minors/`,
        createData,
      )
      .pipe(map((response) => objectToCamel(response)));
  }

  public createClerkTrust(
    courtId: number,
    createData: ClerkCreateTrustPayload,
  ): Observable<ObjectToCamel<TrustClerkCreateApplicationResponse>> {
    return this._http
      .post<ObjectToSnake<TrustClerkCreateApplicationResponse>>(
        `${environment.api}/courts/${courtId}/trusts/`,
        createData,
      )
      .pipe(map((response) => objectToCamel(response)));
  }
}
